import { Progress, Box, Text, Flex } from "@chakra-ui/react"

import { motion } from "framer-motion"
import React from "react"

const MeterBar: React.FC<{
  label: string
  value: number
  max: number
  icon: React.ReactNode
  modifier: number
  color?: string
}> = ({ value, max, icon, modifier, label, color = "#4ca64c" }) => {
  // Calculate the total percentage considering value and modifier
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100) // Ensure it stays between 0% and 100%
  const minValue = Math.min(Math.max(value, 0), max) // Ensure value stays between 0 and max

  // Determine color based on modifier
  const barColor = modifier !== 0 ? "#FF5733" : color

  return (
    <Box width="100%">
      {/* Persistent label with icon */}
      <Flex alignItems="center" justifyContent="center" mb={2} gap={2}>
        {icon}
        <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
          {label}
        </Text>
      </Flex>

      {/* Progress bar */}
      <motion.div
        style={{
          width: "100%",
        }}
        animate={{ color: barColor }}
        initial={{ color: color }}
        transition={{
          color: { duration: 0.33, ease: "easeInOut" },
        }}
      >
        <Progress
          value={percentage}
          colorScheme="gray"
          sx={{
            "& > div": {
              backgroundColor: barColor,
            },
            bg: "gray.200",
          }}
          height="24px"
          borderRadius="full"
        />
      </motion.div>

      {/* Score display */}
      <Text
        textAlign="center"
        mt={2}
        fontSize={{ base: "md", md: "lg" }}
        fontWeight="bold"
      >
        {minValue}
      </Text>
    </Box>
  )
}

export default MeterBar
